export default function anonymous(props
/*``*/) {
var out='<div data-hook="top-block" class="'+(props.styles.topBlock)+'"> <div class="'+(props.styles.elementsContainer)+'"> <div class="'+(props.styles.liveIndicatorContainer)+'" data-hook="live-indicator-container"> </div> <div class="'+(props.styles.titleContainer)+'" data-hook="title-container"> </div> </div></div>';return out;
}


//////////////////
// WEBPACK FOOTER
// ./default-modules/ui/top-block/templates/top-block.dot
// module id = 171
// module chunks = 0 1 2 3 4